import { PermissionCreatePage } from '@/features/access/pages/permission/PermissionCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/access/permission/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_permissions.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PermissionCreatePage,
})
